define([
	"dojo/_base/declare",
	"csi/action",
	"csi/widget/MessageDialog",
	"csi/xml",
	"csi/action/Controller"
], function(declare,csiAction,MessageDialog,xml,Controller) {

	return declare(Controller, {
		_bDeleteOrphans: false,

		confirmAction: function(/*Object*/params) {
			// summary: S11113: Cost Scenario Reset: Prompt user to delete or keep orphan CostMaterial nodes (and handle lack of BOM case)
			params.buttons = [MessageDialog.BUTTON_RESET + MessageDialog.BUTTON_PRIMARY, "Reset_No_Delete", MessageDialog.BUTTON_CANCEL];
			this.inherited(arguments);
		},

		onConfirm: function(/*String*/key) {
			if (key == "C") {
				this.postProcess();
			} else {
				this._bDeleteOrphans = (key == MessageDialog.BUTTON_RESET);
				this.process();
			}
		},

		toWriterRequest: function() {
    		return this.inherited(arguments).addParameter("DeleteOrphans", xml.ATTR_BOOLEAN, this._bDeleteOrphans);
		}
	});
});